module.exports = __webpack_public_path__ + "img/ico_type_rg.3574e47d.svg";